import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const Ctx = createContext();
export const useAuth = () => useContext(Ctx);

const BASE = process.env.REACT_APP_API_URL || '/api';

export function AuthProvider({ children }) {
  const [user, setUser]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('bp_user');
    if (stored) {
      const u = JSON.parse(stored);
      setUser(u);
      axios.defaults.headers.common['Authorization'] = `Bearer ${u.token}`;
    }
    setLoading(false);
  }, []);

  const persist = (u) => {
    setUser(u);
    localStorage.setItem('bp_user', JSON.stringify(u));
    axios.defaults.headers.common['Authorization'] = `Bearer ${u.token}`;
  };

  const login = async (email, password) => {
    const { data } = await axios.post(`${BASE}/auth/login`, { email, password });
    persist(data); return data;
  };

  const register = async (name, email, password) => {
    const { data } = await axios.post(`${BASE}/auth/register`, { name, email, password });
    persist(data); return data;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('bp_user');
    delete axios.defaults.headers.common['Authorization'];
  };

  const refreshUser = async () => {
    try {
      const { data } = await axios.get(`${BASE}/auth/me`);
      const updated = { ...user, ...data };
      setUser(updated);
      localStorage.setItem('bp_user', JSON.stringify(updated));
    } catch {}
  };

  return (
    <Ctx.Provider value={{ user, login, register, logout, refreshUser, loading, isAdmin: user?.role === 'admin' }}>
      {children}
    </Ctx.Provider>
  );
}
